import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-select-portal-user',
  templateUrl: './select-portal-user.component.html',
  styleUrls: ['./select-portal-user.component.css']
})
export class SelectPortalUserComponent implements OnInit {
    custactNo;

    public portalUserSearchButtons: FormButton[] = [{ id: 'search', icon: 'fas fa-search', type: 'primary', onClick: () => this.loadPortalUsers() }];

    public portalUserSearch: string = '';

    public itemsListPortalUsers: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.custactNo = this.stateService.getStateParams()['arg1'];
    }

    private async loadPortalUsers() {
        if (!!this.custactNo) {
            this.itemsListPortalUsers = await this.datatask.Post(95, {
                custact_no: this.custactNo,
                user_name: this.portalUserSearch
            });
        }
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        await this.datatask.Post(96, {
            custact_no: this.custactNo,
            portal_user_keyno: event.item?.item_id
        });

        this.stateService.back();
    }

    public searchItems() {
        this.loadPortalUsers();
    }

    public onBlur(id: string) {
        switch (id) {
            case 'portalUserSearch':
                if (!!this.portalUserSearch) this.loadPortalUsers();
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: string) {
        switch (id) {
            case 'portalUserSearch':
                if (this.portalUserSearch === '') this.loadPortalUsers();
                break;
            default:
                break;
        }
    }

    private async init() {
        if (this.portalUserSearch === '') this.loadPortalUsers();
    }

    ngOnInit() {
        this.init();
    }
}
